// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('analysis.userReports', {
        url: '/userReports',
        templateUrl: 'main/analysis/userReports/userReports.tpl.html',
        controller: 'AnalysisUserReportsController as vm',
        resolve: {
        }
    });
}

// @ngInject
function AnalysisUserReportsController(AnalysisApiService, ToasterService, loadSpinnerService) {
    var vm = this;
}

angular.module('analysis.userReports', [])
    .config(stateConfig)
    .controller('AnalysisUserReportsController', AnalysisUserReportsController);
